export default function encodeName(name) {
  if (!name) {
    return '';
  }
  return name.replace(/\s+/g, '_').replace(/\W+/g, '').replace(/_/g, '-');
}
